import { cn } from '@/lib/utils';

/**
 * Wallet navigation icon. Colors via `currentColor` so the parent's text
 * color (and `transition-colors`) drives the active/inactive animation.
 *
 * @param active - Drives the money's resting position: when `false` the money
 *   (coin + paper bills) sits tucked down inside the wallet; when `true` it
 *   slides up to peek out. The transition is keyed on the `data-active`
 *   attribute in `index.css`. The money shapes carry the `.nav-wallet-money`
 *   class — animating the paths (not their mask groups) keeps the mask windows
 *   fixed, so they appear to slide behind the wallet flap.
 */
export function WalletIcon({ active, className, ...props }: React.SVGProps<SVGSVGElement> & { active?: boolean }) {
  return (
    <svg
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('nav-icon nav-icon--wallet', className)}
      data-active={active ? 'true' : undefined}
      {...props}
    >
      <g clipPath="url(#clip0_wallet)">
        <path
          d="M24.0646 13.8286H18.7034C17.0322 13.8286 15.6777 15.1613 15.6777 16.8047C15.6777 18.4485 17.0326 19.7808 18.7034 19.7808H24.0646C24.4807 19.7808 24.8182 19.4489 24.8182 19.0396V14.5693C24.8182 14.1601 24.4807 13.8281 24.0646 13.8281V13.8286ZM18.7793 18.1849C18.0032 18.1849 17.3738 17.5658 17.3738 16.8024C17.3738 16.0391 18.0032 15.42 18.7793 15.42C19.5553 15.42 20.1847 16.0391 20.1847 16.8024C20.1847 17.5658 19.5553 18.1849 18.7793 18.1849Z"
          fill="currentColor"
        />
        <path
          d="M22.0362 8.86378H2.89096C1.81099 8.86378 1.20181 8.42467 0.873999 8.03711C0.37976 8.10675 0 8.52461 0 9.0302V23.8868C0 25.0536 0.961353 25.9992 2.14753 25.9992H21.1649C22.3511 25.9992 23.3125 25.0536 23.3125 23.8868V20.5317H18.6087C16.5591 20.5317 14.898 18.8694 14.898 16.8185C14.898 14.7676 16.5596 13.1052 18.6087 13.1052H23.3125V10.1395C23.0412 9.01799 22.0366 8.86424 22.0366 8.86424L22.0362 8.86378Z"
          fill="currentColor"
        />
        <path
          className="nav-wallet-money"
          d="M18.7402 4.17752L19.8671 8.13181L21.1838 8.12638L20.8041 4.89204C20.7457 4.39368 20.2896 4.03552 19.7825 4.08933L18.7402 4.17752Z"
          fill="currentColor"
        />
        <mask
          id="mask0_wallet"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="5"
          width="7"
          height="4"
        >
          <path d="M14.2382 5.98242H8.53125V8.13187H14.2382V5.98242Z" fill="white" />
        </mask>
        <g mask="url(#mask0_wallet)">
          <path
            className="nav-wallet-money"
            d="M11.4001 10.9461C12.759 10.9461 13.8607 9.86251 13.8607 8.5258C13.8607 7.18909 12.759 6.10547 11.4001 6.10547C10.0411 6.10547 8.93945 7.18909 8.93945 8.5258C8.93945 9.86251 10.0411 10.9461 11.4001 10.9461Z"
            fill="currentColor"
          />
        </g>
        <mask
          id="mask1_wallet"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="9"
        >
          <path
            d="M4.09683 8.13243L4.09637 8.12927L14.8887 3.85706L17.599 8.12158L19.4077 8.16047L16.9926 0L0.423828 6.18514L2.16907 8.37212L4.09683 8.13243Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_wallet)">
          <path
            className="nav-wallet-money"
            d="M17.1908 1.56937C17.057 1.09227 16.5375 0.829075 16.0649 0.999114L2.30066 5.94379C1.7393 6.13372 1.59861 6.74514 1.75493 7.25751C1.83999 7.76265 2.28411 8.13303 2.80502 8.13257C6.28676 8.11991 18.6165 8.13936 19.0271 8.10996L17.1904 1.56892L17.1908 1.56937ZM4.09648 8.12986C4.09648 8.12986 4.06107 7.92771 4.06107 7.9345C4.82841 7.68306 4.70841 6.66102 4.70841 6.66102C4.70841 6.66102 15.0851 2.89486 15.0851 2.92425C15.3661 3.71249 16.3044 3.64691 16.3044 3.64691L17.5991 8.12172L4.09648 8.12986Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_wallet">
          <rect width="24.8182" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
